module.exports = __webpack_public_path__ + "static/listening_mobile-f21f24ffd55d01fc765c9d97a1c132a3.webp";